const ar = {
    title: "سياسة الخصوصية",
    lastUpdated: "آخر تحديث: 19 أغسطس 2026",
    blocks: [
        { type: "p", text: "تحترم شركة **KSELL HOLDING LIMITED** (\"K-SELL\" أو \"نحن\" أو \"لنا\") خصوصيتك، ونلتزم بحماية معلوماتك الشخصية." },
        { type: "p", text: "توضح سياسة الخصوصية هذه المعلومات التي نجمعها عند استخدامك لتطبيق K-SELL وخدماته ذات الصلة، وكيف نستخدم هذه المعلومات، وكيف يمكن مشاركتها، والخيارات المتاحة لك." },
        { type: "p", text: "باستخدامك K-SELL، فإنك تقر بأنك قرأت سياسة الخصوصية هذه وفهمتها." },

        { type: "h2", text: "1. المعلومات التي نجمعها" },
        { type: "p", text: "عند استخدام K-SELL، قد نجمع المعلومات التالية:" },
        { type: "h3", text: "الاسم" },
        { type: "p", text: "نجمع اسمك عند إنشاء حساب أو استخدامه. نستخدم اسمك للتعرف على حسابك وتسهيل التواصل بين المستخدمين." },
        { type: "h3", text: "رقم الهاتف" },
        { type: "p", text: "نجمع رقم هاتفك لأغراض إدارة الحساب والتواصل، ولتسهيل التواصل بين المشترين والبائعين." },
        { type: "p", text: "اعتمادًا على الميزات التي تستخدمها، قد يتم إتاحة رقم هاتفك لمستخدم آخر في K-SELL عندما تختار التواصل معه أو عندما يكون ذلك ضروريًا لتسهيل المعاملة." },
        { type: "h3", text: "الموقع" },
        { type: "p", text: "قد نجمع موقعك، وفقًا للأذونات التي تمنحها للتطبيق من خلال جهازك." },
        { type: "p", text: "نستخدم معلومات الموقع لتوفير الميزات المتعلقة بالموقع، بما في ذلك تمكينك من البحث عن إعلانات السيارات وتصفيتها بناءً على موقعك." },
        { type: "p", text: "يمكنك التحكم في أذونات الموقع من خلال إعدادات جهازك. وإذا قمت بتعطيل الوصول إلى الموقع، فقد لا تعمل بعض الميزات المعتمدة على الموقع بشكل صحيح." },

        { type: "h2", text: "2. المعلومات التي يتم جمعها من خلال خدمات التحليلات والخدمات التقنية" },
        { type: "p", text: "يستخدم K-SELL خدمات **Firebase** و**Google Analytics** للمساعدة في تشغيل التطبيق وصيانته وتأمينه وتحسينه." },
        { type: "p", text: "وبحسب خدمات Firebase وGoogle Analytics وإعداداتها المستخدمة في K-SELL، قد يتم جمع معلومات تقنية ومعلومات حول الاستخدام، مثل:" },
        { type: "ul", items: [
            "معلومات الجهاز وطرازه؛",
            "نظام التشغيل وإصدار التطبيق؛",
            "أحداث استخدام التطبيق والتفاعل معه؛",
            "معرّفات تثبيت التطبيق أو مثيل التطبيق؛",
            "عنوان IP والمعلومات التقنية ذات الصلة؛",
            "معلومات حول كيفية تفاعلك مع التطبيق؛",
            "معلومات التشخيص والأداء والأمان."
        ] },
        { type: "p", text: "قد تختلف المعلومات التي يتم جمعها حسب خدمات Firebase وGoogle Analytics التي يتم تفعيلها في تطبيق K-SELL." },
        { type: "p", text: "قد تقوم Firebase وGoogle Analytics بمعالجة المعلومات نيابةً عنا لتوفير خدمات التحليلات والبنية التحتية للتطبيق والأمان ومراقبة الأداء والخدمات ذات الصلة." },

        { type: "h2", text: "3. كيفية استخدام معلوماتك" },
        { type: "p", text: "قد نستخدم المعلومات التي نجمعها من أجل:" },
        { type: "ul", items: [
            "إنشاء وإدارة حساب K-SELL الخاص بك؛",
            "التحقق من حسابك وتأمينه؛",
            "تمكين المشترين والبائعين من التواصل؛",
            "تسهيل التواصل المتعلق بإعلانات السيارات؛",
            "توفير ميزات البحث والتصفية حسب الموقع؛",
            "عرض إعلانات السيارات ذات الصلة بناءً على موقعك المحدد أو المتاح؛",
            "تشغيل تطبيق K-SELL وصيانته؛",
            "مراقبة أداء التطبيق وموثوقيته؛",
            "اكتشاف ومنع والتحقيق في الاحتيال أو إساءة الاستخدام أو الحوادث الأمنية؛",
            "تحليل استخدام التطبيق وتحسين خدماتنا؛",
            "الامتثال للالتزامات القانونية المعمول بها؛",
            "الرد على الطلبات والأسئلة أو استفسارات الدعم."
        ] },

        { type: "h2", text: "4. مشاركة المعلومات" },
        { type: "p", text: "نحن لا نبيع معلوماتك الشخصية." },
        { type: "p", text: "قد نشارك المعلومات أو نتيح الوصول إليها في الحالات التالية:" },
        { type: "h3", text: "مع مستخدمي K-SELL الآخرين" },
        { type: "p", text: "قد يتم إتاحة المعلومات اللازمة لتسهيل التواصل بين المشترين والبائعين للمستخدمين الآخرين." },
        { type: "p", text: "على سبيل المثال، قد تتم مشاركة رقم هاتفك مع مستخدم آخر عندما يكون ذلك ضروريًا للتواصل بين المشترين والبائعين أو عندما تختار التواصل مع مستخدم آخر." },
        { type: "p", text: "قد يتم استخدام معلومات الموقع لتوفير ميزات البحث والتصفية حسب الموقع. ولن نقوم بشكل متعمد بالكشف عن موقعك الدقيق للمستخدمين الآخرين إلا إذا كانت إحدى ميزات K-SELL تتطلب ذلك أو تعرض هذه المعلومات بشكل واضح." },
        { type: "h3", text: "مع مزودي الخدمات" },
        { type: "p", text: "نستخدم مزودي خدمات من جهات خارجية، بما في ذلك Firebase وGoogle Analytics، لتوفير خدمات مثل البنية التحتية للتطبيق والتحليلات والأمان ومراقبة الأداء." },
        { type: "p", text: "قد يقوم هؤلاء المزودون بمعالجة المعلومات وفقًا لشروطهم وسياسات الخصوصية الخاصة بهم." },
        { type: "h3", text: "لأسباب قانونية وأمنية" },
        { type: "p", text: "قد نكشف عن المعلومات عندما يكون ذلك ضروريًا بشكل معقول من أجل:" },
        { type: "ul", items: [
            "الامتثال للقوانين واللوائح أو الإجراءات القانونية المعمول بها؛",
            "حماية حقوق أو ممتلكات أو سلامة K-SELL أو مستخدمينا أو الآخرين؛",
            "اكتشاف أو منع الاحتيال أو إساءة الاستخدام أو التهديدات الأمنية؛",
            "تنفيذ شروطنا وسياساتنا."
        ] },

        { type: "h2", text: "5. Firebase وGoogle Analytics" },
        { type: "p", text: "يستخدم K-SELL خدمات Firebase وGoogle Analytics المقدمة من Google." },
        { type: "p", text: "تساعدنا هذه الخدمات على فهم كيفية تفاعل المستخدمين مع التطبيق، ومراقبة أداء التطبيق، وتحديد المشكلات التقنية، وتحسين K-SELL." },
        { type: "p", text: "قد تتضمن المعلومات التي تتم معالجتها من خلال هذه الخدمات معلومات تقنية ومعلومات الجهاز ومعلومات استخدام التطبيق والمعرّفات وأحداث التحليلات، وذلك حسب الخدمات والإعدادات التي يستخدمها K-SELL." },
        { type: "p", text: "لمزيد من المعلومات حول كيفية معالجة Google للمعلومات، يرجى مراجعة معلومات الخصوصية المعمول بها لدى Google." },

        { type: "h2", text: "6. أمن البيانات" },
        { type: "p", text: "نتخذ تدابير تقنية وتنظيمية معقولة لحماية المعلومات التي نجمعها من الوصول أو التغيير أو الكشف أو الإتلاف غير المصرح به." },
        { type: "p", text: "ومع ذلك، لا توجد وسيلة لنقل المعلومات إلكترونيًا أو تخزينها تكون آمنة بشكل كامل، ولذلك لا يمكننا ضمان أمن معلوماتك بشكل مطلق." },

        { type: "h2", text: "7. الاحتفاظ بالبيانات" },
        { type: "p", text: "نحتفظ بالمعلومات الشخصية طالما كان ذلك ضروريًا بشكل معقول لتقديم خدمات K-SELL، وإدارة حسابك، وتسهيل المعاملات والاتصالات، والامتثال للالتزامات القانونية، وحل النزاعات، وتنفيذ اتفاقياتنا، وحماية أمن خدماتنا." },
        { type: "p", text: "عندما لا تعود المعلومات مطلوبة لهذه الأغراض، قد نقوم بحذفها أو إخفاء هويتها وفقًا لممارسات الاحتفاظ المعمول بها لدينا والالتزامات القانونية." },

        { type: "h2", text: "8. حذف الحساب والبيانات" },
        { type: "p", text: "يمكنك حذف حساب K-SELL والمعلومات الشخصية المرتبطة به من خلال تطبيق K-SELL." },
        { type: "p", text: "لحذف حسابك:" },
        { type: "ol", items: [
            "افتح تطبيق K-SELL.",
            "افتح القائمة الجانبية.",
            "اختر **الإعدادات (Settings)**.",
            "اختر **حذف الحساب (Delete Account)**.",
            "اتبع التعليمات الموجودة في التطبيق."
        ] },
        { type: "p", text: "يمكنك أيضًا طلب حذف حسابك من خلال صفحة حذف الحساب عبر الإنترنت:" },
        { type: "strong", text: "[أدخل رابط صفحة حذف الحساب هنا]" },
        { type: "p", text: "عند تقديم طلب حذف الحساب، سنقوم بحذف الحساب والمعلومات الشخصية المرتبطة به، باستثناء الحالات التي يُطلب منا فيها أو يُسمح لنا قانونيًا بالاحتفاظ بمعلومات معينة لأغراض قانونية أو أمنية أو لمنع الاحتيال أو حل النزاعات أو لأغراض تنظيمية." },
        { type: "p", text: "قد لا يكون من الممكن إزالة بعض المعلومات التي تمت مشاركتها بالفعل مع مستخدمين آخرين أو المعلومات المطلوبة للاحتفاظ بها لأسباب قانونية أو أمنية بشكل فوري." },

        { type: "h2", text: "9. خصوصية الأطفال" },
        { type: "p", text: "لا يستهدف K-SELL الأطفال الذين تقل أعمارهم عن 13 عامًا." },
        { type: "p", text: "لا نقوم عن علم بجمع معلومات شخصية من الأطفال الذين تقل أعمارهم عن 13 عامًا. وإذا علمنا أننا جمعنا معلومات شخصية من طفل دون سن 13 عامًا دون الحصول على التفويض المناسب، فسنتخذ خطوات معقولة لحذف تلك المعلومات." },

        { type: "h2", text: "10. خياراتك" },
        { type: "p", text: "يمكنك:" },
        { type: "ul", items: [
            "مراجعة وتحديث بعض المعلومات المرتبطة بحسابك؛",
            "التحكم في أذونات الموقع من خلال إعدادات جهازك؛",
            "حذف حساب K-SELL الخاص بك؛",
            "طلب معلومات حول المعلومات الشخصية التي نحتفظ بها عنك؛",
            "التواصل معنا بشأن الأسئلة أو الطلبات المتعلقة بالخصوصية."
        ] },

        { type: "h2", text: "11. خدمات الجهات الخارجية" },
        { type: "p", text: "يستخدم K-SELL خدمات تابعة لجهات خارجية، بما في ذلك Firebase وGoogle Analytics." },
        { type: "p", text: "قد تقوم هذه الخدمات بمعالجة المعلومات وفقًا لسياسات الخصوصية والشروط الخاصة بها." },

        { type: "h2", text: "12. التغييرات على سياسة الخصوصية" },
        { type: "p", text: "قد نقوم بتحديث سياسة الخصوصية هذه من وقت لآخر لتعكس التغييرات التي تطرأ على K-SELL أو خدماتنا أو المتطلبات القانونية أو ممارساتنا المتعلقة بالبيانات." },
        { type: "p", text: "عندما نجري تغييرات جوهرية، قد نقدم إشعارًا مناسبًا من خلال التطبيق أو بوسائل معقولة أخرى." },
        { type: "p", text: "يشير تاريخ \"آخر تحديث\" الموجود في بداية سياسة الخصوصية هذه إلى تاريخ آخر تحديث لها." },

        { type: "h2", text: "13. التواصل معنا" },
        { type: "p", text: "إذا كانت لديك أسئلة أو مخاوف أو طلبات تتعلق بسياسة الخصوصية هذه أو معلوماتك الشخصية، يرجى التواصل معنا:" },
        { type: "strong", text: "KSELL HOLDING LIMITED" },
        { type: "email", label: "البريد الإلكتروني:", email: "info@ksell.iq" },
        { type: "hr" },
        { type: "p", text: "تنطبق سياسة الخصوصية هذه على تطبيق K-SELL للهواتف المحمولة والخدمات ذات الصلة التي تديرها شركة KSELL HOLDING LIMITED." }
    ]
};

export default ar;
